import React from 'react';
import { PRIMARY, BORDER_LIGHT, TEXT_MUTED, BG_CARD } from './designTokens';

interface ViewToggleProps {
  activeView: 'grid' | 'floorplan' | 'visual' | 'table-names';
  onChange: (view: 'grid' | 'floorplan' | 'visual' | 'table-names') => void;
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'inline-flex',
    borderRadius: '6px',
    border: `1px solid ${BORDER_LIGHT}`,
    overflow: 'hidden',
    marginBottom: '0.75rem',
  },
  button: {
    padding: '0.4rem 0.85rem',
    fontSize: '0.8rem',
    fontWeight: 500,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: BG_CARD,
    color: TEXT_MUTED,
    transition: 'background-color 0.15s, color 0.15s',
  },
  buttonActive: {
    padding: '0.4rem 0.85rem',
    fontSize: '0.8rem',
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: PRIMARY,
    color: '#ffffff',
    transition: 'background-color 0.15s, color 0.15s',
  },
};

export function ViewToggle({ activeView, onChange }: ViewToggleProps) {
  return (
    <div style={styles.container} role="group" aria-label="View mode">
      <button
        style={activeView === 'grid' ? styles.buttonActive : styles.button}
        onClick={() => onChange('grid')}
        aria-pressed={activeView === 'grid'}
      >
        Grid View
      </button>
      <button
        style={activeView === 'floorplan' ? styles.buttonActive : styles.button}
        onClick={() => onChange('floorplan')}
        aria-pressed={activeView === 'floorplan'}
      >
        Floorplan View
      </button>
      <button
        style={activeView === 'visual' ? styles.buttonActive : styles.button}
        onClick={() => onChange('visual')}
        aria-pressed={activeView === 'visual'}
      >
        Visual Layout
      </button>
      <button
        style={activeView === 'table-names' ? styles.buttonActive : styles.button}
        onClick={() => onChange('table-names')}
        aria-pressed={activeView === 'table-names'}
      >
        Table Names
      </button>
    </div>
  );
}
